{
	"title": "Η σελίδα δεν βρέθηκε (404)",
	"description": "Αυτή η σελίδα δεν βρέθηκε επειδή είτε δεν έχετε τα απαραίτητα δικαιώματα πρόσβασης για να την ανοίξετε είτε επειδή δεν υπάρχει. Εάν έχετε επικολλήσει τη διεύθυνση URL, βεβαιωθείτε ότι αντιγράφηκε σωστά.",
	"secondaryButtonTitle": "Άνοιγμα {{page}}"
}
